import { Components, Theme } from '@mui/material/styles';

const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    input: ({ theme }) => ({
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    }),
  },
};

export default MuiInputBase;
